import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "Charles Smith & Associates";

const EXACT_ROUTES = {
  "/": `${BASE_TITLE} | Commercial Refrigeration & Kitchen Equipment`,
  "/products": `Browse Products | ${BASE_TITLE}`,
  "/products/detail": `Product Details | ${BASE_TITLE}`,
  "/contact/us": `Contact Us | ${BASE_TITLE}`,
  "/about/us": `About Us | ${BASE_TITLE}`,
  "/thankyou": `Thank You | ${BASE_TITLE}`,
  "/action": `Action Status | ${BASE_TITLE}`,
  "/dashboard": `Dashboard | ${BASE_TITLE}`,
  "/orders": `My Documents & Orders | ${BASE_TITLE}`,
  "/login": `Login | ${BASE_TITLE}`,
  "/signup": `Sign Up | ${BASE_TITLE}`,
  "/forgotpassword": `Forgot Password | ${BASE_TITLE}`,
  "/reset-password": `Reset Password | ${BASE_TITLE}`,
  "/changepassword": `Change Password | ${BASE_TITLE}`,
  "/create-password": `Create New Password | ${BASE_TITLE}`,
  "/cart": `Shopping Cart | ${BASE_TITLE}`,
  "/payment/failed": `Payment Failed | ${BASE_TITLE}`,
  "/order/confirmed": `Order Confirmed | ${BASE_TITLE}`,
  "/estimate/status": `Estimate Status | ${BASE_TITLE}`,
  "/profile": `My Profile | ${BASE_TITLE}`,
  "/editprofile": `Edit Profile | ${BASE_TITLE}`,
  "/track/orders": `Track Orders | ${BASE_TITLE}`,
  "/privacy-policy": `Privacy Policy | ${BASE_TITLE}`,
  "/terms-and-conditions": `Terms & Conditions | ${BASE_TITLE}`,
};

const PREFIX_ROUTES = [
  { prefix: "/order/tracking/detail", title: `Order Tracking Detail | ${BASE_TITLE}` },
  { prefix: "/estimate/detail", title: `Estimate Details | ${BASE_TITLE}` },
  { prefix: "/invoice/detail", title: `Invoice Details | ${BASE_TITLE}` },
];

export const getTitleForPath = (pathname) => {
  if (EXACT_ROUTES[pathname]) {
    return EXACT_ROUTES[pathname];
  }

  for (const route of PREFIX_ROUTES) {
    if (pathname.startsWith(route.prefix)) {
      return route.title;
    }
  }

  return `Page Not Found | ${BASE_TITLE}`;
};

export default function RouteTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getTitleForPath(pathname);
  }, [pathname]);

  return null;
}
